import { motion } from "framer-motion";

export function HeroVisual({ y, rotate, image }) {
  return (
    <div className="lg:col-span-5 relative">
      <motion.div style={{ y, rotate }} className="relative">
        <div
          aria-hidden
          className="absolute -inset-3 border border-gold/30 rounded-[2rem] translate-x-4 translate-y-4"
        />
        <motion.img
          initial={{ opacity: 0, scale: 1.06 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.4, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          src={image}
          alt="Jeweler welding a permanent necklace chain in the studio — now booking"
          data-testid="hero-image"
          className="relative rounded-[2rem] object-cover w-full aspect-[3/4] shadow-2xl"
        />
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.95, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          data-testid="hero-floating-card"
          className="absolute -left-3 sm:-left-10 top-8 bg-white/90 backdrop-blur-md border border-stone-200/70 rounded-2xl px-5 py-4 shadow-xl max-w-[230px]"
        >
          <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-gold mb-1">
            Welded without a clasp
          </p>
          <p className="font-serif text-sm text-ink leading-snug">
            Gold filled &amp; sterling silver chains, fitted precisely to you.
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
}
